import React from 'react';
import logo from "../images/logo_mini.svg";
import help from "../images/header/help_button.svg";
import logout from "../images/header/logout_button.svg";
import './Header.css'
import agent from "../agent";
import {USER_ROLE_KEY} from "../constants/Constants";
export default class Header extends React.Component
{
    handleLogout = () => {
        if (this.props.canLogout)
            agent.Auth.logout();
        this.props.onLogout();
    }
    handleSupport(){
        agent.Game.reset(this.props.gameId);
    }
    handleHelp() {
        this.props.onToggleDictionary();
    }
    constructor() {
        super();
        this.handleLogout = this.handleLogout.bind(this);
    }
    render() {
        return (
            <div className="header">
                <div className="header-title-bg" style={this.props.role === USER_ROLE_KEY ? {borderTop:"60px solid #003A70",
                    borderRight: "24px solid transparent"} : {borderTop:"60px solid #E42C19",
                    borderRight: "24px solid transparent"} }>
                    <div className="header-logo">
                        <img src={logo}  alt="Корпоративный Университет РЖД" />
                    </div>
                    <div className="header-text text-30">
                        <p  style={{color:"white"}}><b>{this.props.fullName}</b></p>
                    </div>
                </div>
                <div className="header-right-part">
                    <div className="header-btn" onClick={this.handleHelp.bind(this)}>
                        <img src={help} className="header-btn-icon" alt=""/>
                    </div>
                    <div className="header-btn" onClick={this.handleLogout}>
                        <img src={logout} className="header-btn-icon"  alt=""/>
                    </div>
                </div>
            </div>

        );
    }
}
